import React from 'react';

/**
 * Reusable form input component with validation
 * @param {Object} props
 * @param {React.Component} props.icon - Icon component from lucide-react
 * @param {string} props.label - Input label
 * @param {string} props.name - Input name
 * @param {string} props.type - Input type (text, email, tel, url)
 * @param {string} props.value - Input value
 * @param {Function} props.onChange - Change handler
 * @param {string} props.error - Validation error message
 * @param {boolean} props.required - Whether field is required
 */
const FormInput = ({
    icon: Icon,
    label,
    name,
    type = 'text',
    value,
    onChange,
    error,
    required = false
}) => {
    return (
        <div>
            <label className="flex items-center text-sm font-medium text-gray-700 mb-2">
                {Icon && <Icon className="w-4 h-4 mr-2 text-cabaza-purple" />}
                {label} {required && '*'}
            </label>
            <input
                type={type}
                name={name}
                value={value}
                onChange={(e) => onChange(name, e.target.value)}
                className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-0 focus:border-cabaza-purple ${error ? 'border-cabaza-pink' : 'border-gray-300'
                    }`}
            />
            {error && <p className="mt-1 text-xs text-cabaza-pink">{error}</p>}
        </div>
    );
};

export default FormInput;
